import React from 'react';
import { motion } from 'framer-motion';
export function BenefitsSection() {
  const benefits = [{
    icon: '🕊',
    text: 'Reduces la ansiedad y el "ruido mental" que interfiere con tu paz y tu oración'
  }, {
    icon: '🙏',
    text: 'Fortaleces tu fe con práctica diaria real, no solo con deseo o emoción pasajera'
  }, {
    icon: '💡',
    text: 'Ganas claridad para tomar decisiones con paz, no desde el pánico o la urgencia'
  }, {
    icon: '💰',
    text: 'Mejoras tu relación con el dinero desde gratitud, administración y confianza en Dios'
  }, {
    icon: '📿',
    text: 'Profundizas tu conexión con Dios a través de hábitos simples, constantes y obedientes'
  }, {
    icon: '🧠',
    text: 'Aprendes a renovar tu mente con verdad bíblica aplicada a tu vida cotidiana'
  }, {
    icon: '🔓',
    text: 'Identificas y debilitas creencias de culpa, escasez y control que frenan tu avance'
  }, {
    icon: '🏠',
    text: 'Creas más orden en tu vida interior y en tus decisiones del día a día'
  }, {
    icon: '💪',
    text: 'Desarrollas constancia espiritual sostenible, sin depender del ánimo del momento'
  }, {
    icon: '🌱',
    text: 'Das pasos pequeños pero reales hacia la vida que Dios tiene para ti'
  }, {
    icon: '❤️',
    text: 'Caminas con dignidad como hijo(a) de Dios, desde la gracia y no desde el miedo'
  }, {
    icon: '🎯',
    text: 'Terminas cada día con una acción concreta alineada con tu fe y tu oración'
  }];
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-18">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-12 text-center" data-id="element-19">
            Lo que cambia cuando entrenas tu interior con fe
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-20">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="flex items-start gap-4 bg-white p-5 rounded-lg shadow-sm" data-id="element-21">
                <span className="text-3xl flex-shrink-0" data-id="element-22">{benefit.icon}</span>
                <p className="text-dark/80" data-id="element-23">{benefit.text}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}